import { TruFormElement } from './embed/tru-form-element';

// Register the custom element
if (typeof window !== 'undefined' && !customElements.get('tru-form')) {
    customElements.define('tru-form', TruFormElement);
}

// Export for programmatic use
export { TruFormElement, FormFieldValue, FormFieldMetadata, CrmMappingInfo } from './embed/tru-form-element';
export { FormLoaderService, FormData, FormSettings } from './embed/form-loader.service';
export { FormValidator, ValidationError, ValidationResult } from './embed/form-validator';

// Also expose on window for non-module usage
if (typeof window !== 'undefined') {
    (window as any).TruFormsEmbed = {
        TruFormElement,
        version: '1.0.0'
    };
}
